export type EBillingInterval = 'MONTHLY' | 'YEARLY';

/** A Stripe price for display, in the minor unit of the list's currency (cents, Rappen), excluding VAT. */
export interface IPrice {
	productKey: string;
	interval: EBillingInterval;
	unitAmount: number;
}

/**
 * The company's prices in its currency, from Stripe through the billing endpoint; the dashboard never hard-codes
 * amounts. `currencyFixed`: Stripe fixed the currency with the first subscription.
 */
export interface IPriceList {
	currency: string;
	currencyFixed: boolean;
	prices: IPrice[];
}

/** Yearly billing costs 10 months: 2 months free, as on the website's price calculator. */
export const YEARLY_MONTHS_FREE = 2;

/**
 * The unit price (major unit) of a product for an interval; a product sold yearly only bills yearly. Null until the
 * prices are loaded, or when Stripe has no price for the product.
 */
export function unitPriceOf( prices: IPriceList | null, productKey: string, interval: EBillingInterval ): { price: number, interval: EBillingInterval } | null {
	const of = ( i: EBillingInterval ) => prices?.prices.find( p => p.productKey === productKey && p.interval === i );
	const price = of( interval ) ?? of( 'YEARLY' );
	return price ? { price: price.unitAmount / 100, interval: price.interval } : null;
}
